import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class QueryParamsLsStore {

}

export enum QueryParamsLsStoreKeys {

}
